'use client';

import {
  Flex,
  Text,
  CheckboxGroup,
  Checkbox,
  FlexProps,
} from '@chakra-ui/react';
import { FC } from 'react';
import {
  IFilterGroup,
  IFilterObject,
} from '@/components/Product/Filters/types';

interface FilterItemsProps {
  filterGroup: IFilterGroup;
  filters?: IFilterObject[];
  onFiltersChange?: (val: IFilterObject[]) => void;
  containerProps?: FlexProps;
}
const FilterItems: FC<FilterItemsProps> = ({
  filterGroup,
  filters = [],
  onFiltersChange,
  containerProps,
}) => {
  const { key, items } = filterGroup;
  const activeItems =
    filters?.filter((f) => f.key === key).map((f) => f.value) ?? [];

  const handleChange = (updatedItems: string[]) => {
    const trimmedFilters = filters?.filter((f) => f.key !== key) ?? [];
    onFiltersChange?.([
      ...trimmedFilters,
      ...updatedItems.map((it) => ({ key, value: it })),
    ]);
  };

  return (
    <CheckboxGroup value={activeItems} onChange={handleChange}>
      <Flex
        flexDir="column"
        gap="0.75rem"
        userSelect="none"
        {...containerProps}
      >
        {items.map((it) => (
          <Checkbox value={it} key={it}>
            <Text
              color="primary.300"
              cursor="pointer"
              userSelect="none"
              fontSize="0.9375rem"
              fontWeight="300"
              lineHeight="1.25rem"
            >
              {it}
            </Text>
          </Checkbox>
        ))}
      </Flex>
    </CheckboxGroup>
  );
};

export default FilterItems;
